import { CategoryModel } from './category.model';

export class RestrictionModel {
  Id: string;
  name: string;
  category: CategoryModel;
  price: number;
  integrationId: string;
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/restriction.mode.ts